import React from 'react';

/**
 * Products reported as unavailable in the latest audit of each store, and the stores affected by
 * the selected product.
 */
export function useMissingProducts(storeChecks, setStoreChecks) {
    const [products, setProducts] = React.useState([]);
    const [stChecks, setStChecks] = React.useState([]);
    const [filteredChecks, setFilteredChecks] = React.useState([]);
    const [selected, setSelected] = React.useState('');

    const onChange = (value) => {
        setSelected(value);
        setFilteredChecks(stChecks.filter((store) => store?.products?.some((product) => product.name === value && product.isAvailable === false)));
    };

    const prepareData = () => {
        const storeIds = new Set();
        const prodsSet = new Set();

        const checks = storeChecks?.reduceRight((acc, sc) => {
            if (!storeIds.has(sc?.storeId?._id)) {
                storeIds.add(sc?.storeId?._id);
                acc.push(sc);
            }
            return acc;
        }, []);

        setStChecks(checks);

        checks?.forEach((store) => store?.products?.forEach(({ isAvailable, name }) => !isAvailable && prodsSet.add(name ?? '')));

        const productsList = Array.from(prodsSet).map((prod) => ({ label: prod, value: prod }));

        if (productsList.length) {
            setProducts(productsList);
            setSelected(productsList[0].value);
        }
    };

    React.useEffect(() => {
        prepareData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storeChecks, setStoreChecks]);

    React.useEffect(() => {
        if (selected) onChange(selected);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stChecks, selected]);

    return { products, filteredChecks, selected, onChange, missingCount: products.length };
}
